import {
  Box,
  Container,
  FormControl,
  FormControlLabel,
  Radio,
  RadioGroup,
  Stack,
  Typography,
} from "@mui/material";
import { PageTitle } from "../../commanComponents/PageTitle";
import { String } from "../../constants/Strings";
import { LinearProgressBar } from "../../commanComponents/LinearProgressBar";
import { ReactComponent as FamilyChildPlanning } from "../../assets/img/parentchildgoaljourney.svg";
import { getColor } from "../../style/color/color";
import ACRButton from "../../commanComponents/ACRButton";
import { useContext, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { DataContext } from "../../Hooks/context/ChildData";
import { useSavingGoals } from "../../api/apiEndpoints/SavingGoals";
import { AuthContext } from "../../Hooks/context/AuthContext";
import CustomSnackbar from "../../commanComponents/CustomerSnackbar";
import { fonts } from "../../style/fonts/fonts";
import { gaCustomEvent } from "../../logic/CommonFunctions";
import { OTPVerifyContext } from "../../Hooks/context/OTPVeriryContext";

const YesNoQuestion = ({ question, name, onHandleChange, childplan }) => (
  <Box
    sx={{
      textAlign: "center",
      mb: "70px",
    }}
  >
    <Typography
      variant="body1"
      sx={{
        mb: "15px",
        fontSize: 16,
        fontFamily: fonts.manrope,
        fontWeight: "700",
        color: getColor.NeutralDark700,
      }}
    >
      {question}
    </Typography>
    <FormControl
      sx={{
        flexDirection: "row",
        justifyContent: "center",
      }}
    >
      <RadioGroup
        aria-labelledby="demo-radio-buttons-group-label"
        defaultValue={String.Yes}
        name={name}
        onChange={onHandleChange}
        sx={{
          flexDirection: "row",
        }}
      >
        <FormControlLabel
          value={String.Yes}
          sx={{
            fontSize: 16,
            fontFamily: fonts.manrope,
            fontWeight: "700",
            color: getColor.NeutralDark700,
          }}
          control={<Radio />}
          label={String.Yes}
        />
        <FormControlLabel
          value={String.No}
          disabled={childplan}
          sx={{
            fontSize: 16,
            fontFamily: fonts.manrope,
            fontWeight: "700",
            color: getColor.NeutralDark700,
          }}
          control={<Radio />}
          label={String.No}
        />
      </RadioGroup>
    </FormControl>
  </Box>
);

const ChildPlanningQuestion = () => {
  const [answers, setAnswers] = useState({
    question1: String.Yes,
  });
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackbarmessage, setSnackbarMessage] = useState({});

  const navigation = useNavigate();
  const location = useLocation();

  const { collectData, collectedData } = useContext(DataContext);
  const { verifyData } = useContext(OTPVerifyContext);

  const { saveGoals } = useSavingGoals();
  const { authTokens } = useContext(AuthContext);
  const { userId } = authTokens;

  const childplan = location.state.childPlanningData;
  const mutliGoal = location.state.multipleGoal;

  const onHandleChange = (e) => {
    gaCustomEvent(String.gaEventName.acrPortfolio, String.gaEventClickName.acrPortfolioParent, verifyData.customerId);
    const { name, value } = e.target;

    setAnswers((prevAnswer) => ({
      ...prevAnswer,
      [name]: value,
    }));
  };
  const handleContinue = async () => {
    gaCustomEvent(String.gaEventName.acrPortfolio, String.gaEventClickName.acrPortfolioParentContinue, verifyData.customerId);

    if (answers.question1 === String.Yes) {
      collectData({ isParent: true, mutlipleGoal: mutliGoal });
      return navigation(String.navigations.childquestion);
    } else if (answers.question1 === String.No && mutliGoal) {
      return navigation(
        collectedData.selectedGoals.includes(4)
          ? String.navigations.retirementgoal
          : String.navigations.investmentgoal
      );
    } else if (answers.question1 === String.No) {
      try {
        const data = {
          userId: userId,
          isParent: false,

          goals: [1],
          children: [],
          dependents: [],
        };
        const response = await saveGoals(data);
        if (response.httpCode === 200) {
          setSnackbarOpen(true);
          setSnackbarMessage({
            message: String.successMessageforGoalsave,
            severity: String.successSeverity,
          });
          setTimeout(() => {
            navigation(String.navigations.fetchinfo);
          }, 1000);
        } else {
          setSnackbarOpen(true);
          setSnackbarMessage({
            message: String.errorMessageforGoalsave,
            severity: String.ErrorSeverity,
          });
        }
      } catch (error) {
        setSnackbarOpen(true);
        setSnackbarMessage({
          message: String.errorMessageforGoalsave,
          severity: String.ErrorSeverity,
        });
      }
    }
  };
  return (
    <Container
      sx={{
        height: "100vh",
      }}
    >
      <Box sx={{ flexGrow: 1 }}>
        <PageTitle PageTitle={String.ChildPlannig.Title} />
        <LinearProgressBar
          dragMessage={String.ChildPlannig.dragMessage}
          progress={38}
          progressNumber={38}
          stepNumber={2}
        />
        <Stack
          sx={{
            height: "100%",
            justifyContent: "center",
            alignItems: "center",
            mt: { xs: "8%", md: "30%" },
            mb: "30px",
          }}
        >
          <FamilyChildPlanning
            style={{
              width: "100%",
              maxWidth: "450px",
              objectFit: "contain",
            }}
          />
        </Stack>
        <Box sx={{ mt: "10px" }}>
          <YesNoQuestion
            name="question1"
            onHandleChange={onHandleChange}
            question={String.ChildPlannig.question1}
            childplan={childplan}
          ></YesNoQuestion>
        </Box>
      </Box>

      <Box sx={{ display: "flex", justifyContent: "center", mt: "30px" }}>
        <ACRButton
          label={String.continue}
          style={{
            width: "100%",
            height: "60px",
            maxWidth: "350px",
            backgroundColor: getColor.ColorButtonPrimarysurface,
            color: getColor.PrimaryWhite,
            borderRadius: "40px",
            p: "10px",
            mt: "20px",
            mb: "40px",
            lineHeight: "22.2px",
            fontWeight: 700,
            fontSize: "16px",
            textAlign: "center",
            textTransform: "initial",
          }}
          onClickButton={handleContinue}
        />
      </Box>
      <CustomSnackbar
        open={snackbarOpen}
        handleClose={() => setSnackbarOpen(false)}
        severity={snackbarmessage.severity}
        message={snackbarmessage.message}
      />
    </Container>
  );
};
export default ChildPlanningQuestion;
